<template>
    <div class="header-switch">
        <form action="" @change="updateLocale">
            <span class="switch-input--wrapper">
                <input id="locale-cs" v-model="localeInput" name="locale" type="radio" value="cs">
                <label for="locale-cs" class="radio-label">
                    <strong>CZ</strong>
                </label>
            </span>
            <span class="switch-input--wrapper">
                <input id="locale-sk" v-model="localeInput" name="locale" type="radio" value="sk">
                <label for="locale-sk" class="radio-label">
                    <strong>SK</strong>
                </label>
            </span>
            <span class="switch-input--wrapper">
                <input id="locale-de" v-model="localeInput" name="locale" type="radio" value="de">
                <label for="locale-de" class="radio-label">
                    <strong>DE</strong>
                </label>
            </span>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        coachAdmin: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localeInput: null
        }
    },
    mounted() {
        this.localeInput = this.user.locale
    },
    methods: {
        updateLocale() {
            axios.put(`/coach-admins/${this.coachAdmin.id}/locale`, { language: this.localeInput })
        }
    }
}
</script>
